<template>
  <section class="addressList" :style="{height:heighto+'px'}">
    <header-com/>
    <ul v-if='list.length > 0'>
      <li v-for="(item, index) in list" :key="index" @click="toAddressEdit(item.id)">
        <h3 class="f28 bold oneClamp">{{item.province}} {{item.city}} {{item.district}} {{item.address}} </h3>
        <h4 class="f28 grey9"><span>{{item.contacts}}</span><span>{{item.mobile}}</span></h4>
        <div class="isDefault f20" v-if='item.isDefault'>默认地址</div>
      </li>
    </ul>

    <div v-else>
      <img src='/images/base/noAdress.png'>
    </div>
    <div class="g-fixed-bottom t_right dont-fix-bug">
      <button class="primary"  @click="toAddressEdit(0)">添加地址</button>
    </div>
  </section>
</template>

<script>
  import myApi from '@/axios/my'
  export default {
    name: 'addressList',
    components: {},
    data () {
      return {
        list: []
      }
    },
    watch: {},
    computed: {
      heighto(){
        return window.screen.height
      }
    },
    created () {
      this.getAdress()
    },
    mounted () {

    },
    methods: {
      toAddressEdit (type) {
        if(type){
          this.$router.push({ name: 'addressEdit',query:{aid:type}})
        }else{
          this.$router.push({ name: 'addressEdit'})
        }
        
      },
      getAdress () {
        myApi.customerAddress({}).then((res)=>{
          this.list = res;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

.primary{
  position: absolute;
  right: 30px;
  top:9px;
}
img{
  width:100%;
  margin-top: 30%;
}
.addressList{
  padding: 100px 20px 0;
  ul{
    padding-bottom: 120px;
  }
  li{
    padding:36px 20px 34px;
    border-radius: $base-radius;
    box-shadow: $base-shadow;
    margin-bottom: 20px;
    background: url("/images/public/arrow_right.png") no-repeat 97% 46px;
    background-size: 12px;
    position: relative;
    h3{
      margin-bottom: 14px;
    }
    h3,h4{line-height: 40px;width: 600px}
    span{margin-right: 30px}
    .isDefault{
      color: $brand-color;
      line-height: 28px;
      position: absolute;
      top:92px;
      right: 20px;
    }
  }
}
.dont-fix-bug{
  z-index: 18;
}
</style>
